import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Reveal } from "../../lib/motion";

export const Eyebrow = ({ children, light = false, testid }) => (
  <p data-testid={testid} className={`label ${light ? "text-white/60" : "text-primary"}`}>{children}</p>
);

export const SectionHead = ({ eyebrow, title, light = false, className = "", testid }) => (
  <Reveal className={`max-w-3xl ${className}`}>
    {eyebrow && <Eyebrow light={light}>{eyebrow}</Eyebrow>}
    <h2
      data-testid={testid}
      className={`${eyebrow ? "mt-5" : ""} text-balance text-3xl font-semibold leading-[1.1] sm:text-4xl lg:text-[2.75rem] ${light ? "text-white" : "text-foreground"}`}
    >
      {title}
    </h2>
  </Reveal>
);

export const PrimaryCTA = ({ to = "/contact", children, testid, light = false }) => (
  <Link
    to={to}
    data-testid={testid}
    className={`group inline-flex items-center gap-2.5 rounded-full px-7 py-3.5 text-sm font-semibold transition-colors duration-300 ${
      light ? "bg-white text-[#011E6E] hover:bg-[#FAFAF8]" : "bg-[#0133BA] text-white hover:bg-[#011E6E]"
    }`}
  >
    {children}
    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
  </Link>
);

export const TextLink = ({ to, href, onClick, children, testid, light = false }) => {
  const cls = `group inline-flex items-center gap-2 text-sm font-semibold ${light ? "text-white" : "text-primary"}`;
  const inner = (
    <>
      <span className="link-underline">{children}</span>
      <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
    </>
  );
  if (href) return <a href={href} onClick={onClick} data-testid={testid} className={cls}>{inner}</a>;
  return <Link to={to} data-testid={testid} className={cls}>{inner}</Link>;
};

export const scrollToId = (id) => (e) => {
  e.preventDefault();
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const Section = ({ id, dark = false, tint = false, className = "", children, testid }) => (
  <section
    id={id}
    data-testid={testid}
    className={`relative py-24 md:py-32 ${
      dark ? "bg-[#011E6E] text-white" : tint ? "bg-secondary/60" : "bg-background"
    } ${className}`}
  >
    <div className="container-x relative">{children}</div>
  </section>
);
